import type { FaireProductEntity } from "../../entity_types/product";

export const p_fkep3mqh83: FaireProductEntity = {
  token: "p_fkep3mqh83",
  type: "product",
  name: "JESUS IS KING Letter Bracelet",
  brandToken: "b_k5p875q9mb",
  brandName: "Holy Pals",
  imageUrl:
    "https://cdn.faire.com/fastly/9b505587c371f4dd68112eccf852ce3547169e02aa9790b74bf180c1a1470c9d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd22bdcc960e85913f87af23355707ef6691d5a004e2c8ea0a97e385c99f49eb.jpeg",
    "https://cdn.faire.com/fastly/e0071e8a8adea579a61cc3f0dcf21af46f44ce3791c9bcc9237112122f2d8748.jpeg",
    "https://cdn.faire.com/fastly/ae839b7b0e6890c1e9bc93f26d04165b20f89dc62767ff08238682517b46af48.jpeg",
  ],
  priceDollars: 13.58,
  description:
    "Loud and clear—Jesus is King! This gold-beaded bracelet is a statement piece that keeps your faith front and center. Whether you wear it solo or stack it with your other favorites, it’s a simple but powerful way to show who’s reigning in your heart.\n\n * Shiny Gold Beads – Elegant, eye-catching, and timeless \n * Stretch Fit – Easy to slip on and comfortable for all-day wear \n * Faithful Statement – A daily declaration of Christ’s reign \n * Perfect Gift – A meaningful way to share your faith with a loved one \nDeclare to everyone that Jesus is King! 👑\n\nDiameters: \nXS - 15cm\nS - 17cm\nM - 19cm\n",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:33.123Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
